import React from 'react';
import { TableProps } from './index';

export const TableContext = React.createContext<TableProps | undefined>(
  undefined,
);
